import React from 'react';

const BlankHomePage = () => {
    return(<div></div>);
}

export default BlankHomePage;